"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitziersErrorHandler = void 0;
const restless_1 = require("@restless/restless");
const sanitziersErrorHandler = (error, _req, res, next) => {
    if (error instanceof restless_1.SanitizeError) {
        return res.status(400).json({
            error: `Request contains invalid data: ${JSON.stringify(error.errors)} `,
        });
    }
    next(error);
};
exports.sanitziersErrorHandler = sanitziersErrorHandler;
//# sourceMappingURL=errorHandlers.js.map